<template>
    <div class="app-container py-4">
        <v-row class="d-flex justify-center mx-0">
            <v-col cols="12" md="4" class="hidden-sm-and-down pr-4">
                <profile-menu @logout="logout" :active-link="5"></profile-menu>
            </v-col>
            <v-col sm="8">
                <h1 class="justify-center pa-0">{{ $t('productUpdating') }}</h1>
                <v-stepper v-model="steps" class="background-transparent">
                    <div class="d-flex justify-center">
                        <v-stepper-header class="stepper-header">
                            <v-stepper-step
                                :complete="steps > 1"
                                step="1"
                                color="main--yellow "
                            >
                                <div>
                                    {{$t('productData')}}
                                </div>
                            </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step
                                :complete="steps > 2"
                                step="2"
                                color="main--yellow "
                            >
                                <div>
                                    {{$t('characteristics')}}
                                </div>
                            </v-stepper-step>
                        </v-stepper-header>
                    </div>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <main-info-step
                                ref="mainInfoStep"
                                @validated="onMainInfoValidated"
                                @category-change="categoryChange"
                                @remove-image="removeImage"
                                :initial="mainInfoInitial"
                            ></main-info-step>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <characteristics-step
                                :productAttributes="productCharacteristics"
                                ref="characteristicsStep"
                                @back="goBack"
                                @validated="onCharacteristicsValidated"
                                :initial="attributesInitial"
                            ></characteristics-step>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
        <load-overlay :overlay="overlay"></load-overlay>
        <snack-general :snack-data="snackData"></snack-general>
    </div>
</template>

<script>
import './product-add.scss'

import ProfileProductService from '../../../../app-front/services/api/ProfileProductsService';
import ImagesService from '../../../../app-front/services/api/ImagesService';
import InfoService from "../../../../app-front/services/api/InfoService";

import AppSnack from '../../../../general/mixins/AppSnack';
import CharacteristicsStep from './CharacteristicsStep';
import MultipleImageInput from '../../../../general/image/multiple-image-input';
import MainInfoStep from './MainInfoStep';
import ProductAttribute from './ProductAttribute';
import ProfileMenu from '../../../../app-front/components/profile/menu';
import LoadOverlay from "../../../../app-front/components/overlays/LoadOverlay";

import RouteAccess from '../../../../app-front/mixins/RouteAccess';
import WatchLogoutRedirect from '../../../../app-front/mixins/WatchLogoutRedirect';
import SnackGeneral from '../../../../app-front/components/snacks/SnackGeneral';


export default {
    name: "ProductUpdate",
    props: ['id'],
    mixins: [
        AppSnack,
        RouteAccess,
        WatchLogoutRedirect
    ],
    components:{
        MultipleImageInput,
        ProductAttribute,
        MainInfoStep,
        CharacteristicsStep,
        ProfileMenu,
        SnackGeneral,
        LoadOverlay
    },
    data() {
        return {
            attributesValues:{},
            metaUrl: '/profile/products-update/' + this.id,
            steps: 1,
            dialog: false,
            formData: {},
            manufacturerAttributeName: 'proizvoditel',
            productCharacteristics: [],
            productInitial: null,
            showForm: true,
            result: {
                css: '',
                header: '',
                id: null
            },
            snackData: {
                isOpen: false,
                color: '',
                text: ''
            },
            overlay: false
        }
    },
    computed: {
        mainInfoInitial() {
            if(!this.productInitial)
                return {};

            const {
                categoryParent, category,
                name_ru, name_ua,
                articleNumber, images,
                pack, price
            } = this.productInitial;

            const manufacturer = this.productInitial.attributes.enumAttributes.find(item => item.attributeSystemName === this.manufacturerAttributeName) || {};

            return {
                categoryParent, category,
                name_ru, name_ua,
                articleNumber, images,
                pack, price, manufacturer
            }
        },
        attributesInitial() {
            if(!this.productInitial)
                return {};

            const {attributes, description_ru, description_ua} = this.productInitial;

            return {attributes, description_ru, description_ua};
        },
    },
    methods: {
        assignData(data) {
            this.formData = Object.assign(this.formData, data);
        },
        categoryChange(categoryID) {
            if(!categoryID) {
                this.productCharacteristics = [];

                return false;
            }

            InfoService.setLocale(this.$store.state.language.appLanguage);
            InfoService.getAttributesCategory(categoryID)
                .then(res => {
                    this.productCharacteristics = res.data;
                })
                .catch(err => {
                    console.log(err)
                })
        },
        saveProduct() {
            // this.closeSnack();
            this.overlay = true;
            ProfileProductService.updateProduct(this.getFormData())
                .then(res => {
                    this.snackHandle(this.$t('yourProductSaved'), 'main--black', true);
                    this.$emit('success',res.data);
                    this.steps = 1;
                    this.resetSnack();
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('dataSuccessUpdated'));
                    setTimeout(() => {
                        this.overlay = false;
                        this.openSnack();
                        this.setInitial();
                    },2000)
                })
                .catch(err => {
                    this.snackHandle(this.$t('changesSavedError'), 'error', true);
                    this.resetSnack();
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('dataErrorUpdated'));
                    this.openSnack();
                    this.$emit('error')
                    this.overlay = false;
                });
        },
        getFormData() {
            const formData = new FormData();
            formData.append('id', this.id);
            Object.keys(this.formData).forEach(key => {
                if(key === 'productImages') {
                    this.formData[key].forEach(item => {
                        let name = 'images[]';
                        formData.append(name, item);
                    });
                } else {
                    formData.append(key, JSON.stringify(this.formData[key]))
                }
            });

            return formData;
        },
        goBack() {
            if (this.steps > 1) {
                this.steps -= 1;
            }
        },
        onMainInfoValidated(data) {
            this.steps = 2;
            this.assignData(data);
        },
        onCharacteristicsValidated(data) {
            this.assignData(data);
            this.resetSnack();
            this.setInfoSnack();
            this.setConfirmSnackState();
            this.setSnackText(this.$t('save') + '?');
            this.openSnack();
            this.saveProduct();
        },
        removeImage(id) {
            const params = {
                id: this.id,
                imageID: id
            };

            ImagesService.removeProductImage(params)
                .then(res => {
                    if (this.productInitial.images) {
                        const idx = this.productInitial.images.findIndex(item => item.id === res.data);
                        this.productInitial.images.splice(idx, 1);
                    }

                    this.resetSnack();
                    this.setSuccessSnack();
                    this.setSnackText(this.$t('dataSuccessUpdated'));
                    this.openSnack();
                })
                .catch(err => {
                    this.resetSnack();
                    this.setDeleteSnack();
                    this.setSnackText(this.$t('dataErrorUpdated'));
                    this.openSnack();
                    console.log(err)
                });

        },
        setInitial() {
            ProfileProductService.setLocale(this.$store.state.language.appLanguage);
            ProfileProductService.getInitial(this.id)
                .then(res => {
                    this.productInitial = res.data;
                })
                .catch(err => {console.log(err)});
        },
        snackHandle(text, color, isOpen) {
            this.snackData.color = color;
            this.snackData.text = text;
            this.snackData.isOpen = isOpen;
        },
    },
    created() {
        this.setInitial();
    },
    watch: {
        steps() {
            window.scrollTo(0, 0);
        }
    }
}
</script>
